export var cleanTooltips = function () {
    var ps = Array.from(document.querySelectorAll('.tooltip'));
    ps.forEach(function (e) { return e.remove(); });
};
//# sourceMappingURL=index.js.map